import React, { useState } from "react";
import { SVGMap } from "react-svg-map";
import MoscowRegion from "maps/regionMaps/moscowRegion";
import "maps/regionMaps/moscowRegion/index.css";
import PropTypes from "prop-types";
import styles from "./MoscowRegionMap.module.styl";

export default function MoscowRegionMap({ highlightedRegions }) {
    const [currentLocationName, setCurrentLocationName] = useState(null);
    const [toolTipStyle, setToolTipStyle] = useState({
        display: "none",
    });

    const handleLocationMouseOver = function (event) {
        const pointedLocation = getLocationName(event);
        setCurrentLocationName(pointedLocation);
    };

    const handleLocationMouseOut = function () {
        setCurrentLocationName(null);
        setToolTipStyle({ display: "none" });
    };

    const handleLocationMouseMove = function (event) {
        const tooltipStyle = {
            display: "flex",
            top: event.clientY + 90,
            left: event.clientX + 10,
        };
        setToolTipStyle(tooltipStyle);
    };

    const getLocationName = function (event) {
        return event.target.attributes.name.value;
    };

    const getLocationClassName = function (location, index) {
        if (highlightedRegions.includes(location.id)) return `svg-map__location--highlight`;
        else return `svg-map__location`;
    };

    return (
        <>
            <SVGMap
                className={styles.map}
                map={MoscowRegion}
                locationClassName={getLocationClassName}
                onLocationMouseOver={handleLocationMouseOver}
                onLocationMouseOut={handleLocationMouseOut}
                onLocationMouseMove={handleLocationMouseMove}
            />
            <div className="map__tooltip" style={toolTipStyle}>
                {currentLocationName}
            </div>
        </>
    );
}

MoscowRegionMap.propTypes = {
    highlightedRegions: PropTypes.array.isRequired,
};
